var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTanzania(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51446 20.4853C4.01785 20.9887 4.55495 21.4376 5.11834 21.8329L21.8326 5.11863C21.4374 4.55524 20.9884 4.01814 20.485 3.51475C19.9816 3.01136 19.4446 2.56249 18.8812 2.16724L2.16699 18.8815C2.56215 19.4448 3.01112 19.9819 3.51446 20.4853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51422 3.51465C-0.271495 7.30047 -0.998292 12.986 1.33247 17.5021L17.5016 1.33295C12.9856 -0.997814 7.29999 -0.27097 3.51422 3.51465Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4854 20.4853C24.2711 16.6996 24.9979 11.014 22.6672 6.49792L6.49805 22.6671C11.014 24.9978 16.6996 24.271 20.4854 20.4853Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/4015ee43.svg";
export { SvgTanzania as ReactComponent };